import api from "./api";

class CompanyService {
    search(term, params = {}) {
        return api.get("/api/companies/", { params: { search: term, ...params } });
    }

    list(params = {}) {
        return api.get("/api/companies/", { params });
    }

    get(id) {
        return api.get(`/api/companies/${id}/`);
    }
}

export default new CompanyService();
